import { IntegrationsStore } from '@/core/store/Integrations'
import { integrationsModule } from '@/core/modules/integrations/integrations.module'
import { usePendingProviders } from '@/core/hooks/usePendingProviders/usePendingProviders'
import { ProviderActivationCard } from '@/ui/components/ProviderActivationCard'
import MicrosoftIcon from '@/assets/images/microsoft-icon.svg?react'
import {
    EmptyStateWrapper,
    Heading,
    Description,
} from './CloudAppIntegrationsEmptyState.styles'

// ASM-4935: empty state currently only offers Microsoft 365 — Google Workspace
// onboarding from this surface is out of scope for the initial rollout.
const CloudAppIntegrationsEmptyState = () => {
    const microsoftProvider =
        IntegrationsStore.getProviderByType('ms_fraud_defense')
    const { isCurrentProviderLoading } = usePendingProviders(microsoftProvider)
    const { isScansLoading } = IntegrationsStore.useStore()
    const isLoading = isCurrentProviderLoading || isScansLoading

    const handleConnect = () => {
        if (!microsoftProvider || isLoading) return
        integrationsModule.handleIntegrationLogin({
            providerId: microsoftProvider.id,
            type: microsoftProvider.type,
            origin: 'users-page',
            action: 'add',
        })
    }

    return (
        <EmptyStateWrapper data-testid="cloud-app-integrations-empty-state">
            <Heading variant="m-semibold">
                Get More Visibility into Your Organization's Users
            </Heading>
            <Description variant="s-regular">
                Connect your Microsoft 365 to automatically discover user
                accounts, detect account takeover attempts, and protect your
                team from phishing and email-based threats.
            </Description>
            <ProviderActivationCard
                icon={<MicrosoftIcon />}
                title="Connect Microsoft 365"
                onClick={handleConnect}
                isLoading={isLoading}
                disabled={!microsoftProvider || isLoading}
                compact
                dataTestId="cloud-app-empty-state-connect-microsoft-card"
            />
        </EmptyStateWrapper>
    )
}

export default CloudAppIntegrationsEmptyState
